import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconImages2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="images-2, photos, pictures, shot"><path d="M4.1 15.9L8 12L15.9 19.9M3.75 3.75H20.25V20.25H3.75V3.75ZM16.5 9.5C16.5 10.6046 15.6046 11.5 14.5 11.5C13.3954 11.5 12.5 10.6046 12.5 9.5C12.5 8.39543 13.3954 7.5 14.5 7.5C15.6046 7.5 16.5 8.39543 16.5 9.5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconImages2;
